import { BenefitRow } from "entities/benefits";
import { Title } from "pages/ui/page";
import AIIcon from "shared/assets/svgs/ai.svg?react";
import GroupChat from "shared/assets/svgs/group-chat.svg?react";

const GROUP_CHAT_FEATURES = [
  "Invite Resonar to your group chats",
  "Manage tasks, reminders and notes for all members",
  "Assignees can view their tasks in Direct Message",
  "Personal data and connected accounts remain private",
];

export const MoreBenefitsSlide = () => {
  return (
    <div className="w-full shrink-0 pt-7.5">
      <Title className="px-4">More Benefits of Resonar AI</Title>
      <ul className="mt-5 flex flex-col gap-4 px-4.5">
        <BenefitRow
          title="Includes all Standard perks"
          description="This subscription includes all the benefits of the standard subscription."
          icon={<AIIcon className="text-crystal-blue size-10.5 shrink-0" />}
        />
      </ul>
      <div
        className="mx-1.5 mt-4 mb-4 flex items-start gap-4.5 rounded-2xl border border-[rgba(97,201,255,0.4)] px-2.5 py-4 pr-4"
        style={{ background: "rgba(0,0,0,0.3)" }}
      >
        <div className="mb-3 flex items-center gap-x-3">
          <GroupChat className="text-crystal-blue size-10.5 shrink-0" />
        </div>
        <div>
          <h3 className="text-crystal-blue mb-2.5 text-lg leading-tight font-semibold">
            Group Chats Support
          </h3>
          <ul className="flex flex-col gap-2">
            {GROUP_CHAT_FEATURES.map((feature) => (
              <li key={feature} className="flex items-start gap-x-2.5">
                <svg
                  className="mt-0.5 size-4.5 shrink-0 -translate-y-0.5 text-white/40"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5l-4-4 1.41-1.41L10 13.67l6.59-6.59L18 8.5l-8 8z"
                    fill="currentColor"
                  />
                </svg>
                <span className="text-sm leading-4.5 tracking-[0.3px] text-white/50">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
